import eventEnable from '../core/eventEnable';
export default class Binding{
	constructor(name, callbackSet, dispose){
		this._callbackSet = callbackSet;
		this._dispose = dispose;
		this._disposed = false;
		this.getCallbackSet=this.getCallbackSet.bind(this);
		this.callCallbackSet = this.callCallbackSet.bind(this);
		this.dispose= this.dispose.bind(this);
		this._dispatchDispose= this._dispatchDispose.bind(this);
		eventEnable(this);
	}
	getCallbackSet(){
		return this._callbackSet;
	}
	callCallbackSet(value){
		this._callbackSet(value);
	}
	dispose(){
		if(this._disposed)return;
		this._disposed = true;
		this._dispatchDispose();
	}
	_dispatchDispose(){
		this.dispatchEvent({type:'dispose', binding:this});
	}
}